module.exports = __webpack_public_path__ + "about_01.01fd4cba4d6dffb3d602.png";


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/assets/img/about_01.png
// module id = ../../../../../src/assets/img/about_01.png
// module chunks = main